<template>
  <!--文章列表 店铺笔记卡片组件库 -->
  <div class="storenotecard">
    <div v-if="!isShow" :class="{ mask: !isShow }">已隐藏</div>
    <!-- 组件库左侧名称 -->
    <slot name="name" />
    <!-- 没有视频展示默认 -->
    <section
      v-show="!datas.imageList[0]"
      :class="[datas.commodityType === 2 ? 'defaultcommodityList2' : '']"
      class="defaultcommodity"
      @click="handleClickComponent"
      style="box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);"
    >
      <div style="margin: 20px auto; width: 100%; text-align: center">
        <p style="margin-bottom: 50px">请从右侧面板中选择文章</p>
        <div
          class="flex"
          style="text-align: center; margin-top: 50px; justify-content: center"
        >
          <div v-for="item in actionButtons.moduleButtons" :key="item.id">
            <CustomButton
              style="margin-left: 20px"
              v-if="item.id === 'CustomTransfer' || item.id == 'triggerFloat'"
              :text="item.text"
              :outline="item.outline"
              type="primary"
              size="small"
              @click.stop="handleClick(item)"
            />
          </div>
        </div>
      </div>
      <!-- <div v-if="datas.commodityType === 1">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#987654">
          <van-swipe-item     v-for="index in 3" :key="index">
            <div class="defaultcommodityList swiper">
              <div
                class="imgss swiper"
                style="position: relative; width: 100%;"
                :class="[datas.positions === 'top' ? 'containoptions' : '']"
              >
                <img draggable="false"   :src="$imagePath.imageNone" alt="" />
              </div>
              <div
                class="text"
                :class="[datas.positions === 'top' ? 'positionsTop' : '']"
                :style="{
                  background: datas.moditystyle !== 3 ? '#fff' : 'none',
                }"
              >
                <h5>标题</h5>
                <h6>注释文案</h6>
                <div class="dianz">
                  <p class="fir p">
                    一段内容一段内容一段内容一段内容一段内容一段内容11
                    一段内容一段内容一段内容一段内容一段内容一段内容11
                  </p>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div
        v-for="index in 3"
        :key="index"
        class="defaultcommodityList"
        :class="[
          datas.commodityType === 2 ? 'defaultcommodityList2' : '',
          datas.commodityType === 4 ? 'defaultcommodityList4' : '',
        ]"
        :style="{
          'border-radius': datas.borderRadius + 'px',
          border: datas.moditystyle === 2 ? '1px solid rgba(50,50,51,0.1)' : '',
          'box-shadow':
            datas.moditystyle === 1 ? '0 2px 8px rgba(93,113,127,0.08)' : '',
          width:
            datas.commodityType === 1
              ? 50 - datas.commodityMargin / 6 + '%'
              : datas.commodityType === 2
              ? 33 - datas.commodityMargin / 5 + '%'
              : datas.commodityType === 4
              ? 50 - datas.commodityMargin / 5 + '%'
              : '',
        }"
      >
        <div
          v-if="datas.commodityType == 2 || datas.commodityType == 4"
          :class="{
            'defaultcommodityList-content-4': datas.commodityType == 4,
          }"
        >
          <div style="position: relative">
            <van-image
              width="100%"
              height="120"
              fit="cover"
              :src="$imagePath.imageNone"
            />
          </div>
          <div
            class="text"
            :class="[datas.positions === 'top' ? 'positionsTop' : '']"
            :style="{ background: datas.moditystyle !== 3 ? '#fff' : 'none' }"
          >
            <div>
              <h5
                :style="{
                  'font-family': datas.fontFamily,
                  'font-size': datas.fontSize + 'px',
                  color: datas.textColor,
                }"
              >
                标题
              </h5>
              <h6>注释文案</h6>
            </div>
            <div class="dianz">
              <p
                class="fir p"
                :style="{
                  'font-family': datas.subFontFamily,
                  'font-size': datas.subFontSize + 'px',
                  color: datas.subTextColor,
                }"
              >
                一段内容一段内容一段内容一段内容一段内容一段内容
              </p>
            </div>
          </div>
        </div>
      </div> -->
    </section>

    <section
      v-show="datas.imageList[0]"
      :class="[datas.commodityType === 2 ? 'defaultcommodityList2' : '']"
      class="defaultcommodity"
      @click="handleClickHttp(item, index)"
    >
      <!-- 轮播图样式 -->
      <div v-if="datas.commodityType === 1">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#987654">
          <van-swipe-item v-for="(item, index) in datas.imageList" :key="index">
            <div class="defaultcommodityList swiper" style="width: 100%">
              <div
                class="imgss swiper"
                style="position: relative; width: 100%"
                :class="[datas.positions === 'top' ? 'containoptions' : '']"
              >
                <van-image
                  width="100%"
                  height="120"
                  fit="cover"
                  :src="item.src"
                />
                <!-- <img draggable="false" :src="item.src" alt="" /> -->
              </div>
              <div
                class="text"
                :class="[datas.positions === 'top' ? 'positionsTop' : '']"
                :style="{
                  background: datas.moditystyle !== 3 ? '#fff' : 'none',
                }"
              >
                <h5
                  :style="{
                    'font-family': datas.fontFamily,
                    'font-size': datas.fontSize + 'px',
                    color: datas.textColor,
                  }"
                >
                  {{ item.text }}
                </h5>
                <h6
                  :style="{
                    fontSize: datas.fontSize + 'px',
                    color: datas.textColor,
                  }"
                >
                  {{ item.subTitle }}
                </h6>
                <div class="dianz">
                  <CustomCellItem
                    :datas="datas"
                    v-if="datas.isShowMore"
                    :leftContent="item.description + '发达发达发达发达发范德萨'"
                    :rightContent="datas.moreText"
                    rightIcon="el-icon-arrow-right"
                  />
                  <div
                    style="line-height: 20px; width: 100%"
                    v-else
                    :style="{
                      'font-family': datas.subFontFamily,
                      'font-size': datas.subFontSize + 'px',
                      color: datas.subTextColor,
                    }"
                  >
                    <div class="ellipsis" style="width: 100%; height: 100%">
                      {{ $utils.pureChineseText(item.description) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div
        v-for="(item, index) in datas.imageList"
        :key="index"
        class="defaultcommodityList"
        :class="[
          datas.commodityType === 2 ? 'defaultcommodityList2' : '',
          datas.commodityType === 4 ? 'defaultcommodityList4' : '',
        ]"
        :style="{
          'border-radius': datas.borderRadius + 'px',
          border: datas.moditystyle === 2 ? '1px solid rgba(50,50,51,0.1)' : '',
          'box-shadow':
            datas.moditystyle === 1 ? '0 2px 8px rgba(93,113,127,0.08)' : '',
          width:
            datas.commodityType === 1
              ? 50 - datas.commodityMargin / 6 + '%'
              : datas.commodityType === 2
              ? 33 - datas.commodityMargin / 5 + '%'
              : datas.commodityType === 4
              ? 50 - datas.commodityMargin / 5 + '%'
              : '',
        }"
        @click="handleClickHttp(item, index)"
      >
        <div
          v-if="datas.commodityType == 2 || datas.commodityType == 4"
          :class="{
            'defaultcommodityList-content-4': datas.commodityType == 4,
          }"
        >
          <div style="position: relative">
            <van-image
              :width="datas.commodityType == 4 ? 120 : '100%'"
              height="90"
              radius="5"
               fit="cover"
              :src="item.src"
            />
          </div>
          <div
            class="text"
            :class="[datas.positions === 'top' ? 'positionsTop' : '']"
            :style="{ background: datas.moditystyle !== 3 ? '#fff' : 'none', width: datas.commodityType == 4 ? '66%' : '100%' }"
          >
            <div>
              <h5
                class="overflow"
                :style="{
                  'font-family': datas.fontFamily,
                  'font-size': datas.fontSize + 'px',
                  color: datas.textColor,
                  width: datas.commodityType == 4 ? '60%' : '100%',
                }"
              >
                {{ item.text }}
              </h5>
              <h6
                :style="{
                  'font-family': datas.subFontFamily,
                  'font-size': datas.subFontSize + 'px',
                  color: datas.subTextColor,
                }"
              >
                {{ item.subTitle }}
              </h6>
            </div>
            <div class="dianz">
              <CustomCellItem
                v-if="datas.isShowMore"
                :datas="datas"
                :leftContent="item.description"
                :rightContent="datas.moreText"
                rightIcon="el-icon-arrow-right"
              />
              <div
                v-else
                style="line-height: 20px; width: 100%"
                :style="{
                  'font-family': datas.subFontFamily,
                  'font-size': datas.subFontSize + 'px',
                  color: datas.subTextColor,
                }"
              >
                <div
                  class="ellipsis"
                  :style="{
                    width: datas.commodityType == 4 ? '60%' : '100%',
                  }"
                >
                  {{ $utils.pureChineseText(item.description) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 删除组件 -->
    <slot name="deles" />
  </div>
</template>

<script>
// 引入事件总线
import Bus from "@/utils/bus.js";
// 引入相关静态数据配置
import { actionButtons } from "@/utils/defaultData";
export default {
  name: "storenotecard",
  props: {
    datas: Object,
    isShow: Boolean,
  },
  data() {
    return {
      active: 0,
    };
  },
  created() {},

  methods: {
    handleClickComponent() {
      console.log(
        "文章列表子组件点击了组件#####￥",
        this.datas,
        this.datas.parentComponent,
        this.$utils.handleComponentObj({
          id: this.datas.parentComponent,
          ref: `${this.datas.parentComponent}style`,
          text: this.datas.text,
        }),
      );
      this.$emit(
        "handleCallbackComponent",
        this.$utils.handleComponentObj({
          id: this.datas.parentComponent,
          ref: `${this.datas.parentComponent}style`,
          text: this.datas.text,
        }),
        this.datas,
      );
    },
    handleClick(button, row) {
      console.log(
        "文章列表子组件新建文章和选择文章按钮点击11111111",
        button,
        row,
        this.datas,
      );
      this.$emit("handleCallbackComponent", button, row);
    },
    async handleClickHttp(item, index) {
      console.log("点击跳转详情了", item, index, this.datas);
      // 保证点击所有区域都正常显示对应组件的右侧操作面板显示交互
      this.$emit(
        "handleCallbackComponent",
        this.$utils.handleComponentObj({
          id: this.datas.parentComponent,
          ref: `${this.datas.parentComponent}style`,
          text: this.datas.text,
        }),
        this.datas,
      );
      if (item) {
        // 重置当前文章列表详情模块类型
        const pageComponents = Array.from(
          this.$componentProperties.values(),
        ).find((item) => item.component === "detail");
        const pageId =
          "page_" +
          this.datas.parentComponent +
          "_detail_" +
          new Date().getTime();
        const newPage = {
          pageId: item.id,
          isBack: true,
          pageName: "详情",
          path: pageId,
          pageSetup: {
            ...this.$store.state.modules.templateData.global,
            name: item.text,
            showLeftArrow: true,
          },
          components: [pageComponents],
        };

        console.log(
          "列表点击el",
          item,
          index,
          this.datas,
          newPage,
          pageComponents,
        );
        // this.datas.pageId = newPage.pageId;
        if (this.datas.linktype == 10 && !item.http.internalLink) {
          item.http.internalLink = item.id;
          const result = await this.$store.dispatch(
            "modules/addDynamicPage",
            newPage,
          );
          if (result.success) {
            console.log(
              "是否追加新页面成功",
              item,
              result,
              this.$store.state.modules.templateData,
            );
            this.$router.push({
              path: "/productOpenwecartAfter/admin/Edit",
              query: {
                pageId: item.id,
              },
            });
          }
          return;
        }
        console.log("已经有页面id跳转了", item);
        this.$router.push({
          path: "/productOpenwecartAfter/admin/Edit",
          query: {
            pageId: item.id,
          },
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
p {
  margin: 0 !important;
  padding: 0 !important;
  line-height: 10px !important;
}
::v-deep.van-cell {
  padding: 0 !important;
  line-height: 16px !important;
}
.storenotecard {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  /* 更多1 */
  .more1 {
    margin: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    h4 {
      font-size: 16px;
      color: #323233;
      font-weight: 400;
      width: 270px;
    }
    p {
      color: #969799;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
  }

  /* 更多2 */
  .more2 {
    text-align: center;
    color: #969799;
    font-size: 12px;
    margin-bottom: 15px;
  }

  /* 默认商品 */
  .defaultcommodity {
    box-sizing: border-box;
    margin: 1px;
    padding: 15px;
    /* 横向滑动 */
    &.defaultcommodityList2 {
      overflow: scroll;
      display: flex;
      /* 滚动条 */
      &::-webkit-scrollbar {
        height: 1px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #155bd4;
      }
      ::v-deep.el-collapse-item__header,
      ::v-deep.el-collapse-item__wrap {
        border-bottom: 0 !important;
      }
    }
    // 轮播图区域
    .defaultcommodityList.swiper {
      height: 220px;
    }
    /* 卡片列表 */
    .defaultcommodityList {
      position: relative;
      margin-bottom: 15px;
      overflow: hidden;
      display: inline-flex;
      flex-direction: column;
      .defaultcommodityList-content-4 {
        display: flex;
        width: 100%;
        align-items: center;
        box-sizing: border-box;
      }

      /* 大图模式 */
      &.defaultcommodityList0 {
        width: 100%;
        /* 标签 */
        .containoptions {
        }
        img {
          height: 147px;
        }
        /* 文字在图片中 */
        .positionsTop {
          position: absolute;
          display: flex;
          flex-direction: column-reverse;
          left: 0;
          bottom: 0;
          background: none !important;
          background-image: linear-gradient(
            to bottom,
            transparent,
            rgba(0, 0, 0, 0.5)
          ) !important;
          /* 标题 */
          h5 {
            color: #fff;
          }
          span {
            color: #fff;
          }
          /* 点赞和阅读量 */
          .dianz {
            padding-left: 190px;
          }
        }
      }

      /* 一行两个 */
      &.defaultcommodityList1 {
        width: 48%;
        &:nth-of-type(even) {
          margin-left: 4%;
        }
      }

      /* 横向滑动 */
      &.defaultcommodityList2 {
        width: 250px;
        flex: none;
        margin-right: 5%;
      }

      /* 一大两小 */
      &.defaultcommodityList3 {
        display: flex;
        &:nth-of-type(3n-2) {
          margin-bottom: 0 !important;
          img {
            height: 147px;
          }
          /* 文字在图片中 */
          .text {
            position: absolute;
            display: flex;
            flex-direction: column-reverse;
            left: 0;
            bottom: 0;
            background: none !important;
            background-image: linear-gradient(
              to bottom,
              transparent,
              rgba(0, 0, 0, 0.5)
            ) !important;
            /* 标题 */
            h5 {
              color: #fff;
            }
            span {
              color: #fff;
            }
            /* 点赞和阅读量 */
            .dianz {
              padding-left: 190px;
            }
          }
        }
        &:nth-of-type(3n) {
          flex-direction: row;
          margin-bottom: 15px;
          .imgss.swiper {
            height: 67px !important;
          }
          .imgss {
            width: 65px !important;
            height: 67px;
            z-index: 99;
            position: absolute !important;
            top: 10%;
            right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text {
            width: 100%;
            padding: 10px 80px 10px 10px;
            min-height: 87px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .dianz {
              justify-content: start;
              line-height: 20px;
              span {
                &.fir {
                  margin-right: 30px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        &:nth-of-type(3n-1) {
          flex-direction: row;
          margin-bottom: 0;
          border-bottom: 1px solid #e5e5e5;
          border-top: 1px solid #e5e5e5;
          .imgss.swiper {
            height: 67px;
          }
          .imgss {
            width: 65px !important;
            height: 67px;
            z-index: 99;
            position: absolute !important;
            top: 10%;
            right: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .text {
            width: 100%;
            padding: 10px 80px 10px 10px;
            min-height: 87px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .dianz {
              justify-content: start;
              line-height: 20px;
              span {
                &.fir {
                  margin-right: 30px;
                  font-size: 12px;
                }
              }
            }
          }
        }
        &:nth-of-type(3n) {
          flex-direction: row;
        }
      }

      /* 详细列表 */
      &.defaultcommodityList4 {
        width: 100%;
        // 弹性布局翻转
        flex-direction: row;
        margin-bottom: 10px;
        .imgss.swiper {
          height: 67px;
        }
        .imgss {
          width: 120px !important;
          height: 122px;
          z-index: 99;
          position: absolute !important;
          top: 8%;
          right: 10px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .text {
          width: 100%;
          // min-height: 145px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .dianz {
            justify-content: start;
            line-height: 20px;
            span {
              &.fir {
                margin-right: 30px;
                font-size: 12px;
              }
            }
          }
        }
      }

      /* 图片 */
      img {
        width: 100%;
        display: block;
        overflow: hidden;
      }

      /* 文字 */
      .text {
        padding: 10px;
        width: 100%;
        box-sizing: border-box;
        /* 商品名称 */
        h5 {
          font-size: 13px;
          line-height: 20px;
          margin: 0 0 5px;
          font-weight: 800;
        }
        /* 点赞和阅读量 */
        .dianz {
          display: flex;
          justify-content: space-between;
          line-height: 35px;
          span {
            font-size: 11px;
            align-items: center;
            .van-icon-good-job-o {
              margin-right: 5px;
            }
          }
        }
      }
    }
  }
}
</style>
